import SubscriptionTab from "@/components/profile/SubscriptionTab";
import { hidePaywallUI } from "@/lib/platform";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";

const Subscription = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <Card>
          <CardContent className="flex items-center justify-center py-12">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth?tab=signin" replace />;
  }

  // On iOS, Apple forbids selling subscriptions outside IAP. Show a
  // read-only notice instead of the Stripe-powered SubscriptionTab.
  if (hidePaywallUI()) {
    return (
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle>Subscription</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm text-muted-foreground">
            <p>
              Subscription management isn't available in the iOS app. To view
              your plan, update billing or cancel, please visit{" "}
              <span className="font-medium text-foreground">houndpayments.co.uk</span>{" "}
              from a browser and sign in.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Subscription</h1>
        <p className="text-muted-foreground mt-2">
          Manage your Hound Pro plan, billing details, payment methods and SMS credits
        </p>
      </div>
      <SubscriptionTab />
    </div>
  );
};

export default Subscription;
